angular.module('zc.projects')

.directive 'clearanceDownloadButton', ($q) ->
  restrict: 'E'
  scope:
    clearanceItemSet: '='
    clearanceItemSetItems: '='
  template: """
            <button
              type="button"
              class="btn btn-sm btn-default pull-right"
              ng-csv="getCSV()"
              csv-header="csvheader"
              filename="{{filename}}"
              add-bom="true"
              charset="utf-16"
              field-separator="\\t">
              <i class="fa fa-cloud-download"></i> {{ projectsClearance.clearanceDownloadButton.downloadCsv | translate }}
            </button>
            """

  link: (scope, element, attrs) ->
    scope.filename = "#{scope.clearanceItemSet.name}.csv"
    scope.csvheader = ['match_type','path','title','base_price','text_base_price','sale_url','image_url',]

    scope.getCSV = ->
      _.map scope.clearanceItemSetItems, (num) ->
        _.pick num, scope.csvheader



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.clearance/clearance_download_button.directive.coffee